import { render, staticRenderFns } from "./IconsButton.vue?vue&type=template&id=0c06e94b&scoped=true&"
import script from "./IconsButton.vue?vue&type=script&lang=js&"
export * from "./IconsButton.vue?vue&type=script&lang=js&"
import style0 from "./IconsButton.vue?vue&type=style&index=0&id=0c06e94b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06e94b",
  null
  
)

export default component.exports